import { render } from "./PreApplication.vue?vue&type=template&id=1f90b876&scoped=true&ts=true"
import script from "./PreApplication.vue?vue&type=script&lang=ts"
export * from "./PreApplication.vue?vue&type=script&lang=ts"

import "./PreApplication.vue?vue&type=style&index=0&id=1f90b876&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f90b876"]])

export default __exports__